import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { UmbrellaLogo } from "@/components/UmbrellaLogo";
import { CheckCircle2 } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("checking");
  const [ptype, setPtype] = useState("escrow");
  const sessionId = params.get("session_id");

  useEffect(() => {
    let tries = 0;
    const poll = async () => {
      if (!sessionId) { setStatus("error"); return; }
      try {
        const r = await api.get(`/payments/status/${sessionId}`);
        if (r.data.payment_status === "paid") {
          setPtype(r.data.type || "escrow");
          setStatus("paid");
          setTimeout(() => navigate(r.data.type === "featured" ? "/business" : -1), 1800);
          return;
        }
      } catch (e) {
        console.error("Payment status poll failed", e);
      }
      if (tries++ < 8) setTimeout(poll, 1500); else setStatus("timeout");
    };
    poll();
  }, [sessionId]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center text-center px-6">
      {status === "checking" && <><UmbrellaLogo size={44} className="animate-pulse text-slate-950" /><p className="mt-4 text-slate-500">Confirming your payment…</p></>}
      {status === "paid" && (ptype === "featured"
        ? <><CheckCircle2 size={56} className="text-amber-500" /><h1 className="mt-4 font-heading text-2xl font-bold">Your business is now featured!</h1><p className="mt-2 text-slate-500">You'll appear first in Browse results and client job matches. Redirecting…</p></>
        : <><CheckCircle2 size={56} className="text-emerald-500" /><h1 className="mt-4 font-heading text-2xl font-bold">Payment secured in escrow!</h1><p className="mt-2 text-slate-500">Your funds are held safely until the job is complete. Redirecting…</p></>)}
      {(status === "timeout" || status === "error") && <><p className="text-slate-600">We couldn't confirm the payment yet. Check your dashboard shortly.</p><button onClick={() => navigate("/dashboard")} className="mt-4 underline text-amber-600">Go to dashboard</button></>}
    </div>
  );
}
